import decimalFormat from './decimalFormat'
import { memoize } from './function'

const EMPTY_STRING_FORMAT = /^\s+$/

export const getRegexFromString = (string: string | undefined) => {
  try {
    if (string) {
      const json = JSON.parse(string)
      return new RegExp(json.pattern, json.modifiers)
    }
  } catch (err) {
    console.error(err)
  }
}

export const isEmpty = (value: string | null | undefined): boolean =>
  value === undefined ||
  value === 'undefined' ||
  value === null ||
  value === 'null' ||
  value === '' ||
  typeof value !== 'string' ||
  EMPTY_STRING_FORMAT.test(value)

const createFormatter = memoize((format) => decimalFormat(format))

export const formatMoney = (
  amount: number,
  currency?: string,
  format?: string
): string =>
  currency && format && amount !== Infinity && amount !== -Infinity
    ? (createFormatter(format).format(amount) || '').replace(/¤/, currency)
    : String(amount)

export const pad = (str: string, length = 2, p = '0'): string =>
  str === undefined || str === null || str.length >= length
    ? str
    : new Array(length - str.length + 1).join(p) + str

export const makeCombineString =
  (joint = ' ') =>
  (...args: unknown[]): string =>
    [...args]
      .filter((x) => typeof x === 'string' || typeof x === 'number')
      .join(joint)

export const combineString = makeCombineString(' ')

export const replaceAll = (
  string: string,
  search: string,
  replacement: string
): string => string.replace(new RegExp(search, 'g'), replacement)

export const format = (
  string: string,
  func?: (substring: string, ...args: any[]) => string
) => (string && func ? string.replace(/{{(\w+)}}/g, func) : '')

export const capitalizeFirstLetter = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1)
